import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { FONT_BRIGHTNESS, primaryShadow, ThemeProvider, useTheme, useUpdateThemeWithFontBrightness, zIndices, } from '@design-system/theme';
import { TYPES } from '../constants';
import { getBgColor } from '../utils/getBgColor';
import { getPosition } from '../utils/getPosition';
import { getTrianglePosition } from '../utils/getTrianglePosition';
import { renderTriangle } from '../utils/renderTriangle';
export const TooltipPopover = forwardRef(({ children, coords, fixedParent, hideOnScreenReader, id, maxWidth, removeHoverEffect, shouldHideArrow, shouldRender, shouldRenderTooltip, textAlign, theme, tooltipPosition, type, }, ref) => {
    const currentTheme = useTheme();
    const updatedTheme = useUpdateThemeWithFontBrightness(currentTheme, type === TYPES.CARD
        ? currentTheme.themeVariables.frameFontBrightness
        : FONT_BRIGHTNESS.LIGHT);
    return (_jsx("div", { "aria-hidden": hideOnScreenReader ? 'true' : 'false', "data-testid": "tooltip-popover", children: _jsxs(ThemeProvider, { theme: updatedTheme, children: [(shouldRender || shouldRenderTooltip) && removeHoverEffect ? (_jsx(StyledOverlay, {})) : null, _jsx(StyledPopover, Object.assign({}, coords, { "$fixedParent": fixedParent, "$maxWidth": maxWidth, "data-testid": `tooltip-positioned-at-${tooltipPosition}`, id: id, ref: ref, textAlign: textAlign, theme: theme, tooltipPosition: tooltipPosition, type: type, children: children })), !shouldHideArrow && (_jsx(StyledTriangle, Object.assign({}, coords, { "$fixedParent": fixedParent, theme: theme, tooltipPosition: tooltipPosition, type: type })))] }) }));
});
const StyledOverlay = styled.div `
  position: absolute;
  z-index: ${zIndices.tooltip};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
const StyledPopover = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => ![
        'parentHeight',
        'parentWidth',
        'left',
        'top',
        'tooltipPosition',
        'type',
        'theme',
    ].includes(prop),
})
    .attrs(({ $fixedParent, $maxWidth, left, textAlign, theme, top, type }) => ({
    color: type === TYPES.CARD
        ? theme.themeVariables.frameFontBrightness
        : 'white',
    left: { _: 0, m: left !== null && left !== void 0 ? left : undefined },
    maxWidth: { _: 'unset', m: $maxWidth !== null && $maxWidth !== void 0 ? $maxWidth : undefined },
    mx: { _: 4, m: '0' },
    position: $fixedParent ? 'fixed' : 'absolute',
    px: 3,
    py: 2,
    textAlign,
    top,
    width: { _: 'calc(100vw - 32px)', m: 'max-content' },
})) `
  ${getPosition};
  background-color: ${getBgColor};
  border-radius: ${({ theme, type }) => (type === TYPES.CARD ? theme.themeVariables.globalBorderRadius : 3)}px;
  z-index: ${zIndices.tooltip};

  ${({ type }) => (type === TYPES.CARD ? primaryShadow : '')};
  `;
const StyledTriangle = styled(Box)
    .withConfig({
    shouldForwardProp: (prop) => ![
        'parentHeight',
        'parentWidth',
        'left',
        'top',
        'tooltipPosition',
        'type',
        'theme',
    ].includes(prop),
})
    .attrs(({ $fixedParent }) => ({
    position: $fixedParent ? 'fixed' : 'absolute',
})) `
      ${getTrianglePosition};
      content: '';
      display: block;
      width: 0;
      height: 0;
      z-index: ${zIndices.tooltip};
      ${renderTriangle}
      `;
//# sourceMappingURL=TooltipPopover.js.map